import { importProvidersFrom, ApplicationConfig, provideZoneChangeDetection } from "@angular/core"
import { BrowserModule } from "@angular/platform-browser"
import { provideRouter } from "@angular/router"
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async"
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from "@angular/common/http";
import { MsalInterceptor, MSAL_INSTANCE, MsalInterceptorConfiguration, MsalGuardConfiguration, MSAL_GUARD_CONFIG, MSAL_INTERCEPTOR_CONFIG, MsalService, MsalGuard, MsalBroadcastService, MsalModule } from "@azure/msal-angular";
import { IPublicClientApplication, PublicClientApplication, InteractionType, BrowserCacheLocation } from "@azure/msal-browser"
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from "@angular/material/core"
import { environment } from "src/environments/environment"
import { LoadingInterceptor } from "./interceptors"
import { routes } from "./app.routes"
const apiScopes = ["api://" + environment.apiClientId + "/benefits.all"]

const MSALInstanceFactory = (): IPublicClientApplication => {
    return new PublicClientApplication({
        auth: {
            clientId: environment.appClientId,
            authority: environment.msalAuthority,
            redirectUri: environment.redirectUri,
        },
        cache: {
            cacheLocation: BrowserCacheLocation.LocalStorage,
        },
    })
}

const MSALInterceptorConfigFactory = (): MsalInterceptorConfiguration => {
    const protectedResourceMap = new Map<string, Array<string>>()
    protectedResourceMap.set(environment.graphEndpoint, ["user.read"])
    protectedResourceMap.set(environment.apiBaseUrl + "*", apiScopes)

    return {
        interactionType: InteractionType.Redirect,
        protectedResourceMap,
    }
}

const MSALGuardConfigFactory = (): MsalGuardConfiguration => {
    return {
        interactionType: InteractionType.Redirect,
        authRequest: {
            scopes: [...apiScopes],
        },
        loginFailedRoute: "/",
    }
}

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection(),
        provideRouter(routes),
        importProvidersFrom(
            BrowserModule,
            MsalModule,
        ),
        provideHttpClient(withInterceptorsFromDi(), withFetch()),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoadingInterceptor,
            multi: true,
        },
        {
            provide: MSAL_INSTANCE,
            useFactory: MSALInstanceFactory,
        },
        {
            provide: MSAL_GUARD_CONFIG,
            useFactory: MSALGuardConfigFactory,
        },
        {
            provide: MSAL_INTERCEPTOR_CONFIG,
            useFactory: MSALInterceptorConfigFactory,
        },
        MsalService,
        MsalGuard,
        MsalBroadcastService,
        provideAnimationsAsync(),
        provideNativeDateAdapter(),
        {
            provide: MAT_DATE_LOCALE,
            useValue: "hr-HR",
        },
    ]
}

